import React, { Component } from 'react';
import Moment from 'moment';
import { KRBL, BEAM } from 'Constants/commonConstants';
import { getUser } from 'Utils/storage';
import { isDesmet } from 'Utils/index';

export const ApprovalMatrixDetails = ({lineItem, approvalUser, rfq, isRoquette, bid, isDPH}) => {
    return <div>
        <div className="flex flex-row flex-between">
            <span className="section-sub-header-color fBold fs-16">
                Approval Matrix
            </span>
        </div>
        <div className="flex pv-20 border-bottom-light flex-between flex-middle" >
            <div className="flex flex-1 col-3">
                <span className="section-sub-header-color fBold fs-14 op-5">
                    User
                </span>
            </div>
            <div className="flex flex-1 col-3">
                <span className="section-sub-header-color fBold fs-14 op-5 pl-15">
                    Status
                </span>
            </div>
            <div className="flex flex-1 col-3">
                <span className="section-sub-header-color fBold fs-14 op-5">
                    Date
                </span>
            </div>
        </div>
        {   <>
            {
                (isRoquette || [...KRBL, ...BEAM].includes(getUser().companyId)) || isDesmet() ? 
                <>
                {isDPH ?
                <>{bid && ([...(bid.bid_dph_approved_status || []), ...(bid.bid_dph_approver_emails || [])] || []).map((status, index) => {
                    return <div className="flex pv-20 border-bottom-light flex-between flex-middle" key={index}>
                    <div className="flex flex-1 col-3">
                        <span className="section-sub-header-color  fs-14">
                            {((((rfq['approver_names'] || []).find(approver => approver.email === (status.approved_by ? status.approved_by : ((bid.bid_dph_approver_emails || []).join(''))))) || {}).user_name || '')}
                        </span>
                    </div>
                    <div className="flex flex-1 col-3">
                        {(status.dph_approved_date || status.loi_approved_date) ? <span className='success-color'>{'Approved'}</span> : <span className='orange-color'>{'Approval Pending'}</span>}
                    </div>
                    <div className="flex flex-1 col-3">
                        <span className="section-sub-header-color  fs-14">
                            {(status.dph_approved_date || status.loi_approved_date) && Moment((status.dph_approved_date || status.loi_approved_date)).format('DD MMM YYYY HH:mm')}
                        </span>
                    </div>
                    </div>
                    })}
                </> 
                :
                <>{bid && ([...(bid.bid_approved_status || []), ...(bid.bid_approver_emails || [])] || []).map((status, index) => {
                        return <div className="flex pv-20 border-bottom-light flex-between flex-middle" key={index}>
                        <div className="flex flex-1 col-3">
                            <span className="section-sub-header-color  fs-14">
                                {((((rfq['approver_names'] || []).find(approver => approver.email === (status.approved_by ? status.approved_by : ((bid.bid_approver_emails || []).join(''))))) || {}).user_name || '')}
                            </span>
                        </div>
                        <div className="flex flex-1 col-3">
                            {status.loi_approved_date ? <span className='success-color'>{'Approved'}</span> : <span className='orange-color'>{'Approval Pending'}</span>}
                        </div>
                        <div className="flex flex-1 col-3">
                            <span className="section-sub-header-color  fs-14">
                                {status.loi_approved_date && Moment(status.loi_approved_date).format('DD MMM YYYY HH:mm')}
                            </span>
                        </div>
                    </div>
                    })}
                </>}
                </>
            :
            <>
                {lineItem.map((status, index) => {
                    return <div className="flex pv-20 border-bottom-light flex-between flex-middle" key={index}>
                        <div className="flex flex-1 col-3">
                            <span className="section-sub-header-color  fs-14">
                                {(!status.loiApproved && isRoquette) ? (((rfq['approver_names'] || []).find(approver => approver.email === (bid.bid_approver_emails || []).join('')) || {}).user_name || '') : status.usernames.join(',')}
                            </span>
                        </div>
                        <div className="flex flex-1 col-3">
                            {status.loiApproved ? <span className='success-color'>{'Approved'}</span> : (approvalUser === status.usernames.join(',') ? <span className='orange-color'>{'Approval Pending'}</span> : 'Not Sent')}
                        </div>
                        <div className="flex flex-1 col-3">
                            <span className="section-sub-header-color  fs-14">
                                {status.loi_approved_date && Moment(status.loi_approved_date).format('DD MMM YYYY HH:mm')}
                            </span>
                        </div>
                    </div>
                })
                }
            </>
            }</>
        }
    </div>
}